import { makeStyles } from "@material-ui/core"

export const SIDEBAR_EXPANDED_WIDTH_IN_PIXELS = 240
export const SIDEBAR_COLLAPSED_WIDTH_IN_PIXELS = 84

const useStyles = makeStyles({
	routesContainer: {
		height: "100%",
		flex: 1
	},
	routesContent: {
		height: "100%"
	},
	attendanceContainer: {
		height: "100%"
	},
	boardIframeContainer: {
		height: "100%",
		flex: 1
	},
	boardIframe: {
		width: "100%",
		height: "100%",
		border: "none"
	},
	sidebarGridExpanded: {
		width: SIDEBAR_EXPANDED_WIDTH_IN_PIXELS,
		overflow: "hidden",
		flexShrink: 0,
		transition: "width 0.18s"
	},
	sidebarGridCollapsed: {
		width: SIDEBAR_COLLAPSED_WIDTH_IN_PIXELS,
		overflow: "hidden",
		flexShrink: 0,
		transition: "width 0.18s"
	},
	hiddenView: {
		display: "none"
	}
})

export default useStyles
